module.exports = __webpack_public_path__ + "static/media/thanjavur.9f86bdad.jpg";